import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connectToStores } from 'fluxible-addons-react';
import TenantMenuItem from './TenantMenuItem';
import TenantDescription from './TenantDescription';
import ApplicationStore from '../../stores/ApplicationStore';
import styles from './styles.module.styl';

/* eslint-disable react/jsx-no-target-blank */

class AuthDropdown extends Component {
  constructor(props) {
    super(props);

    this.setMenuRef = this.setMenuRef.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.state = {};
  }

  setMenuRef(ref) {
    this.menuRef = ref;
  }

  closeMenu(e) {
    this.setState({ mainMenu: false, tenantMenu: false });
    document.removeEventListener('click', this.handleDocumentClick, false);
  }

  handleDocumentClick(e) {
    if (!this.menuRef.contains(e.target) || e.target.dataset.menuToggle) {
      this.closeMenu();
    }
  }

  toggleMenu(open, menuName) {
    return (e) => {
      const state = {};
      e.preventDefault();

      if (menuName === 'mainMenu') {
        if (open) {
          document.addEventListener('click', this.handleDocumentClick, false);
        } else {
          document.removeEventListener('click', this.handleDocumentClick, false);
        }
      }

      state[menuName] = open;
      this.setState(state);
    };
  }

  render() {
    const { picture, tenant, tenants, userName, manageUrl } = this.props;
    const { mainMenu, tenantMenu } = this.state;

    return (
      <React.Fragment>
        <button
          onClick={this.toggleMenu(!mainMenu, 'mainMenu')}
          className="btn btn-dro btn-username"
        >
          {tenant && (
            <div className="username-text truncate" title={tenant.name}>
              {tenant.name}
            </div>
          )}
          <div className="user-picture">
            <img src={picture} alt="avatar" className="avatar" />
            <i className="icon-budicon-460" />
          </div>
        </button>

        <div ref={this.setMenuRef} className={`dropdown tenant-dropdown ${mainMenu ? 'open' : ''}`}>
          <div
            className={`tenant-menu-container dropdown-menu ${
              tenantMenu ? 'switch-tenant' : ''
            }`}
          >
            <div className="tenant-menu-slide">
              <ul className="tenant-menu">
                {tenant && (
                  <li className={styles.tenantMenuHeader}>
                    <a>
                      <h5 className={styles.tenantName}>{tenant.name}</h5>
                      <TenantDescription
                        regionCode={tenant.regionCode}
                        regionName={tenant.regionName}
                        subscription={tenant.subscription}
                      />
                    </a>
                  </li>
                )}
                <li className="tenant-menu-item">
                  <a href={manageUrl} tabIndex={0} role="menuitem" target="_blank">
                    <i className="tenant-menu-icon icon-budicon-394" />
                    <span className="icon-text">Open Dashboard</span>
                  </a>
                </li>
                {tenants.length > 0 && (
                  <li className="tenant-menu-item">
                    <a
                      onClick={this.toggleMenu(!tenantMenu, 'tenantMenu')}
                      tabIndex={0}
                      role="menuitem"
                      className="tenant-switch-btn"
                    >
                      <i className="tenant-menu-icon icon-budicon-436" />
                      <span className="icon-text">Switch tenant</span>
                    </a>
                  </li>
                )}
                <li className="divider" />
                <li>
                  <div className="user-header clearfix">
                    <div className="profile-picture">
                      <img alt="profile" className="picture" src={picture} />
                    </div>
                    <div className="profile-info">
                      <h5 className="user-name">{userName}</h5>
                      <a href={`${manageUrl}/profile`} target="_blank">
                        View profile
                      </a>
                    </div>
                  </div>
                </li>
                <li className="divider" />
                <li className="tenant-menu-item">
                  <a href="/docs/auth/logout" data-menu-toggle>
                    <i className="tenant-menu-icon icon-budicon-519" />
                    <span className="icon-text">Logout</span>
                  </a>
                </li>
              </ul>

              <ul id="tenant-selector-pane" className="tenant-menu">
                <a
                  onClick={this.toggleMenu(!tenantMenu, 'tenantMenu')}
                  role="menuitem"
                  tabIndex={0}
                  className="tenant-selector-back-arrow tenant-switch-btn"
                >
                  <i className="icon-budicon-521" />
                </a>
                <li className="tenant-selector-header">
                  <h5>Switch tenant</h5>
                </li>
                <ul className="tenant-selector-inner tenant-menu">
                  {tenants.map(t => (
                    <TenantMenuItem
                      data-menu-toggle
                      key={t.url}
                      {...t}
                      selected={tenant.name === t.name && tenant.region === t.region}
                    />
                  ))}
                </ul>
              </ul>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

AuthDropdown.propTypes = {
  picture: PropTypes.string.isRequired,
  manageUrl: PropTypes.string.isRequired,
  tenant: PropTypes.object.isRequired,
  tenants: PropTypes.array.isRequired,
  userName: PropTypes.string.isRequired
};

AuthDropdown.defaultProps = {
  picture: '',
  tenant: {},
  tenants: [],
  userName: ''
};

AuthDropdown.contextTypes = {
  getStore: PropTypes.func.isRequired
};

export default connectToStores(
  AuthDropdown,
  [ApplicationStore],
  context => ({
    manageUrl: context.getStore(ApplicationStore).getDashboardUrl()
  })
);
